"use strict";

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.promise.js");

var _react = require("react");

var _WFS = _interopRequireDefault(require("ol/format/WFS"));

var _GeoJSON = _interopRequireDefault(require("ol/format/GeoJSON"));

var _GML = _interopRequireDefault(require("ol/format/GML2"));

var _GML2 = _interopRequireDefault(require("ol/format/GML3"));

var _GML3 = _interopRequireDefault(require("ol/format/GML32"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useWFSGetFeature = function useWFSGetFeature() {
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isLoading = _useState2[0],
      setIsLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = _slicedToArray(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1]; //const [features, setFeatures] = useState[null]


  var sendRequest = (0, _react.useCallback)(function (url, map, layer, wfsOptions) {
    var fetchOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      method: 'POST',
      contentType: 'application/xml'
    };
    //build WFS request
    var featureRequest = new _WFS.default().writeGetFeature(wfsOptions);
    var data = new XMLSerializer().serializeToString(featureRequest); //log for testing

    console.log('WFS GetFeature Request: ');
    console.log(data); //format fetch options with the content type

    setIsLoading(true);
    setError(null);
    fetchOptions = _objectSpread(_objectSpread({}, fetchOptions), {}, {
      method: 'POST',
      contentType: 'application/xml',
      body: data //dataType: 'json'

    }); //fetch data

    fetch(url, fetchOptions).then(function (response) {
      if (!response.ok) {
        throw new Error(response);
      } //return response.json();


      return response.text();
    }).then(function (responseData) {
      console.log('WFS GetFeature Response:', responseData);
      var parser = null;
      var outputFormat = wfsOptions.outputFormat;
      if (outputFormat) outputFormat = outputFormat.toUpperCase();

      switch (outputFormat) {
        case 'APPLICATION/JSON':
          parser = new _GeoJSON.default();
          break;

        case 'GML2':
          parser = new _GML.default();
          break;

        case 'GML3':
          parser = new _GML2.default();
          break;

        case 'GML32':
          parser = new _GML3.default();
          break;

        default:
          parser = new _GML2.default();
      }

      var features = parser.readFeatures(responseData); //const xml = (new window.DOMParser()).parseFromString(responseData, "text/xml")
      //const features = parser.readFeatures(xml);

      layer.getSource().addFeatures(features);
      setIsLoading(false);
    }).catch(function (error) {
      alert(error.message);
      setError(error.message);
      setIsLoading(false);
    });
  }, []);
  var clearRequest = (0, _react.useCallback)(function () {
    setIsLoading(false);
    setError(null);
  }, []);
  return {
    sendRequest: sendRequest,
    clearRequest: clearRequest,
    isLoading: isLoading,
    error: error
  };
};

var _default = useWFSGetFeature;
exports.default = _default;